import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import Api from '../../../../../helpers/api';

const api = new Api('applicants/:id/accreditations');
const accreditationApi = new Api('applicants/:id/accreditations/:id');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter }, id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* deleteAccreditation({ payload }) {
  try {
    const { id, parent_id } = payload;

    const result = yield call(
      sendRequest,
      accreditationApi.deleteItem,
      { id: [parent_id, id] },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(actions.removeAccreditationSuccess(payload));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.DELETE_ACCREDITATION_REQUEST, deleteAccreditation)]);
}
